/* esm.sh - applesauce-common@5.2.0/dist/helpers/share */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/share.mjs";
